import React from 'react';

import * as styles from '../icons.css';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={60}
    viewBox="0 0 76 92"
    xmlSpace="preserve"
    focusable="false"
    fill="currentColor"
    className={styles.root}
  >
    <path
      fill="none"
      className={styles.stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M60.24 30.152H43.494s4.947-14.656 1-23.761c-2.811-6.468-9.689-3.732-10.975 0-1.195 3.474-9.903 30.824-9.903 30.824l.006-.003a13.577 13.577 0 0 0-1.072 5.299v18.076c0 7.589 6.156 13.748 13.747 13.748H60.24c7.592 0 13.752-6.159 13.752-13.748V43.723c0-7.586-6.16-13.571-13.752-13.571z"
    />
    <path
      className={[styles.stroke, styles.fill].join(' ')}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M35.764 74.336h-26.3a7.456 7.456 0 0 1-7.455-7.459V45.84a7.455 7.455 0 0 1 7.455-7.458h12.49l1.232.065c-.689 1.632-.619 2.184-.619 4.064v18.076c0 7.589 6.156 13.748 13.746 13.748"
    />
    <ellipse className={styles.shadow} cx={38.508} cy={87.5} rx={17} ry={3} />
  </svg>
);
